import React from 'react';
import ECGDeviceMonitor from '../components/ECGDeviceMonitor';

const ECGMonitorPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ECGDeviceMonitor />
      </div>
    </div>
  );
};

export default ECGMonitorPage;
